<template>
    <div class="home-warp container">
        <el-carousel :type="carouselType" :height="carouselHeight">
            <el-carousel-item v-for="item in carouselData" :key="item.id">
                <a v-if="item.link" :href="item.link" target="blank_"><img :src="item.url" alt></a>
                <img v-if="!item.link" :src="item.url" alt>
            </el-carousel-item>
        </el-carousel>
        <el-card class="box-card">
            <div slot="header" class="clearfix"><span class="box-card-title">考试科目</span></div>
            <el-row v-if="course">
                <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12" v-for="(itemCourse) in course" :key="itemCourse.id">
                    <v-course :course="itemCourse" @update="updateCourse"></v-course>
                </el-col>
            </el-row>
        </el-card>
        
        <el-card class="box-card">
            <div slot="header" class="clearfix">
                <span class="box-card-title">考试记录</span>
            </div>
            <el-table :data="tableData" style="width: 100%">
                <el-table-column fixed fit prop="subjectName" label="科目" align="center"></el-table-column>
                <el-table-column prop="createTime" label="考试时间" width="180" align="center"></el-table-column>
                <el-table-column prop="score" :formatter="scoreFormat" label="成绩" width="80" align="center"></el-table-column>
                <el-table-column prop="state" :formatter="stateFormat" label="状态" width="80" align="center"></el-table-column>
                <el-table-column label="操作" width="300" align="left">
                    <template slot-scope="scope">
                        <el-button v-if="scope.row.certificateState == 1" @click="confirmCreate(scope.row.id)"   size="small" type="primary">生成证书</el-button>
                        <el-button v-if="scope.row.certificateState == 2" @click="downLoadCertificate(scope.row.certificateId)"  size="small" type="primary">下载证书</el-button>
                        <el-button v-if="scope.row.surveyUrl" size="small" type="primary" @click="openSurveyUrl(scope.row.surveyUrl)">填写问卷</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </el-card>
        <el-dialog title="证书预览" :visible.sync="certificateVisible" width="60%">
            <div style="min-height:280px;">
                <div class="loading" v-if="loading"><i class="el-icon-loading" ></i></div>
                <img :style="{width:'100%', height: loading?'0':'auto'}" :src="certificateImageUrl" @load="loading=false" @error="loading=false">
            </div>
            <p class="tips">温馨提示：姓名拼音一般格式：Xiaoming Wang  即：姓在后，名在前，首字母要大写。</p>
            <p class="tips">请确认姓名拼音及邮箱。如需修改，请点击“关闭”，在个人信息页面上进行修改。如确认无误，请点击“生成证书”按钮生成证书，证书生成后无法再修改证书上的信息。</p>

            <div slot="footer" class="dialog-footer">
                <el-button @click="certificateVisible = false">关 闭</el-button>
                <el-button type="primary" @click="createCertificate()">生成证书</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import course from "./course.vue";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";

import { quillEditor } from "vue-quill-editor";

export default {
    components: {
        "v-course":course,
        quillEditor
    },
    data: function() {
        return {
            editorOption: {},
            certificateVisible: false,
            createRecordId: "",
            showCourseItem: {},
            dialogVisible: false,
            activeIndex: "1",
            editUserInfo: false,
            carouselData: [],
            carouselType: "",
            carouselHeight: "",
            course: [],
            tableData: [],
            loading: false,
            certificateImageUrl: "",
        };
    },
    computed: {
        userInfo: function() {
            return this.$store.state.userInfo;
        }
    },
    methods: {
        updateCourse() {
            this.$axios.get("/subject/selectSubjectWithFrequency", {
                params: {userId: this.$store.state.userInfo.id}
            })
            .then(response => {
                this.course = response.data;
            });
        },
        getExamRecord() {
            this.$axios
                .get("/record/getRecordByUserId", {
                params: {
                    userId: this.$store.state.userInfo.id
                }
                })
                .then(response => {
                this.tableData = response.data;
                });
        },
        confirmCreate(recordId) {
            if (!this.userInfo.enName || this.userInfo.enName === '') {
                this.$confirm(`个人信息不完整，请前往个人信息补充姓名拼音`, '提示', {
                    confirmButtonText: '确定',
                    showCancelButton: false,
                    showClose: false,
                    type: 'warning'
                }).then(() => {
                    this.$router.push("/user");
                }).catch(() => {
                });
                return;
            }
            this.createRecordId =  recordId;
            this.certificateVisible = true;
            this.loading = true;
            this.certificateImageUrl = `/api/record/preView?time=${new Date().getTime()}&recordId=${this.createRecordId}`;
        },
        createCertificate() {
            this.$axios.get("/record/generateCertificate", {
                params: {
                    recordId: this.createRecordId
                }
            }).then(response => {
                if(response.code == 200) {
                    this.certificateVisible = false;
                    this.$message.success("生成证书成功！");
                    this.getExamRecord();
                }
            });
        },
        downLoadCertificate(certificateId) {
            window.location.href = `/api/record/download/Certificate?certificateId=${certificateId}`;
        },
        openSurveyUrl(surveyUrl) {
            console.log(surveyUrl);
            window.open(surveyUrl);
        },
        showCourse(itemCourse) {
            this.showCourseItem = itemCourse;
            this.dialogVisible = true;
        },
        stateFormat(row, column, state) {
            // if (row.subjectId == 3) {
            //     return '完成考试'
            // }

            if (state === 1) {
                return "考试中";
            // } else if (row.subjectId == 9) {
            //     //第一次上线，暂时不开放成绩
            //     return "批卷中";
            } else if (state === 2) {
                return "批卷中";
            } else if (state === 3) {
                return "通过";
            } else if (state === 4) {
                return "不通过";
            } else if (state === 5) {
                return "考试异常";
            }
        },
        scoreFormat(row, column, score) {
            // if (row.subjectId == 3) {
            //     return "-";
            // }
            if (row.state === 5) {
                //考试异常，不显示成绩
                return "-";
            }
            // if (row.subjectId == 9) {
            //     //第一次上线，暂时不开放成绩
            //     return "-"
            // }
            if (score !== null) {
                return score + "%";
            } else {
                return "-";
            }
        }
    },
    updated() {
        let winWidth;
        if (window.innerWidth) winWidth = window.innerWidth;
        else if (document.body && document.body.clientWidth)
        winWidth = document.body.clientWidth;
        this.carouselType = winWidth > 960 ? "card" : "";
        this.carouselHeight = winWidth > 960 ? "300px" : `${(5 / 8) * winWidth}px`;
    },
    async mounted() {
        // 查询当前开放科目以及考试次数
        this.$axios.get("/subject/selectSubjectWithFrequency", {
            params: {userId: this.$store.state.userInfo.id}
        })
        .then(response => {
            this.course = response.data;
        });
        this.$axios.get("/carousel/selectAll").then(response => {
            this.carouselData = response.data;
        });
        // 查询考试记录
        let res = await  this.$axios.get("/user/getCurrentUser").catch(err => {return {}});
        if (res.code === 200) {
            this.$axios.get("/record/getRecordByUserId", {
                params: {userId: res.data.id}
            }).then(response => {
                this.tableData = response.data;
            });

            if (res.data.faceCertify !== 1 && res.data.faceCertify !== -1 && "true" !== sessionStorage.getItem("skipFaceCertify")) {
                this.$confirm("当前账号尚未实名认证，请前往个人中心进行认证！",'提示',{
                    confirmButtonText: '前往',
                    cancelButtonText: '跳过',
                    showClose: false,
                    type: 'warning'
                }).then(() => {
                    this.$router.push("/user");
                }).catch(()=>{
                    sessionStorage.setItem("skipFaceCertify","true");
                });
            }
        }
    },
    filters: {}
};
</script>
<style>
.container {
    margin-left: auto;
    margin-right: auto;
    max-width: 960px;
}
.loading {
  min-height: 250px;
  line-height: 250px;
  color: #1564a7;
  text-align: center;
}
.el-icon-loading{
  font-size: 60px;
}
</style>

<style scoped>
.title {
  line-height: 60px;
}
.tips {
  /* color: #f56c6c; */
  font-size:14px;
  text-indent: 2em;
}
.home-warp {
  margin-top: 10px;
}
.el-carousel {
  width: 100%;
}
.el-carousel img {
  width: 100%;
}
.downLoad {
  cursor: pointer;
}
.remark {
  text-indent: 2em;
  line-height: 30px;
}
.exam-course {
  margin: 20px 10px;
}

.el-card {
  /* margin: 0 10px; */
}
.box-card {
  width: 100%;
  margin-top: 20px;
}

.time {
  font-size: 13px;
  color: #999;
}

.imgbox {
  /* max-height: 200px; */
  /* overflow: hidden; */
}
.imgbox img {
  width: 100%;
  cursor: pointer;
}
@media screen and (max-width: 767px) {
  .time,
  .el-table {
    font-size: 12px;
  }
  span {
    font-size: 14px;
  }
  .box-card {
    margin-top: 10px;
  }
  .home-warp {
    overflow: hidden;
    margin-top: 0;
  }
}
</style>
